import React from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Paper,
  Divider,
  useTheme
} from "@mui/material";

const EtapaResumoFinal = ({
  companyName,
  selectedAwarenessTitles,
  manualClients,
  manualProducts,
  pipelineSteps,
  requestTypes,
  canaisSelecionados,
  pesquisasConfiguradas,
  cargosConfigurados,
  usuariosCadastrados,
}) => {
  const theme = useTheme();

  const formattedRequestTypes =
    Array.isArray(requestTypes) && requestTypes.length
      ? requestTypes
          .map((rt) => {
            const tipo = rt?.tipo || "";
            const subtipos = Array.isArray(rt?.subtipos)
              ? rt.subtipos.filter((s) => s && String(s).trim())
              : [];
            if (!tipo) return null;
            if (!subtipos.length) return tipo;
            return `${tipo}: ${subtipos.join(", ")}`;
          })
          .filter(Boolean)
          .join(" | ")
      : "";

  return (
    <Box sx={{ width: "100%"}}>
      <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ color: theme.palette.success.main }}>
        🎉 Tudo pronto!
      </Typography>

      <Typography variant="body1" gutterBottom>
        Você finalizou todas as etapas do setup inicial do XPro. A partir de agora, sua empresa conta com uma estrutura completa para atendimento e vendas automatizadas com inteligência artificial.
      </Typography>

      <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 3 }}>
        ✅ O que foi configurado:
      </Typography>

      <Paper variant="outlined" sx={{ mt: 2 }}>
        <List>
          <ListItem>
            <ListItemText
              primary="Nome da Empresa"
              secondary={companyName || "Não informado"}
            />
          </ListItem>

          <Divider />

          <ListItem>
            <ListItemText
              primary="Níveis de Consciência"
              secondary={selectedAwarenessTitles?.join(", ") || "Nenhum nível selecionado"}
            />
          </ListItem>

          <Divider />

          <ListItem>
            <ListItemText
              primary="Clientes Importados"
              secondary={manualClients.length > 0 ? `${manualClients.length} cliente(s)` : "Nenhum cliente cadastrado"}
            />
          </ListItem>

          <Divider />

          <ListItem>
            <ListItemText
              primary="Produtos Cadastrados"
              secondary={manualProducts.length > 0 ? `${manualProducts.length} produto(s)` : "Nenhum produto cadastrado"}
            />
          </ListItem>

          <Divider />

          <ListItem>
            <ListItemText
              primary="Etapas do Pipeline"
              secondary={pipelineSteps.length > 0 ? [pipelineSteps[0].from, ...pipelineSteps.map(p => p.to)].join(" → ") : "Não definido"}
            />
          </ListItem>

          <Divider />

          <ListItem>
            <ListItemText
              primary="Tipos de Solicitação"
              secondary={formattedRequestTypes || "Não definidos"}
            />
          </ListItem>

          <Divider />

          <ListItem>
            <ListItemText
              primary="Cargos"
              secondary={cargosConfigurados.length > 0 ? `${cargosConfigurados.length} cargo(s)` : "Nenhum cargo configurado"}
            />
          </ListItem>

          <Divider />

          <ListItem>
            <ListItemText
              primary="Usuários"
              secondary={usuariosCadastrados.length > 0 ? `${usuariosCadastrados.length} usuário(s) cadastrado(s)` : "Nenhum usuário cadastrado"}
            />
          </ListItem>
        </List>
      </Paper>

      <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }} >
        Você pode revisar ou alterar qualquer informação a qualquer momento pelo painel de configurações. Nosso objetivo é garantir que sua empresa tenha uma jornada eficiente, com atendimento humanizado e inteligente desde o primeiro contato com seus clientes.
      </Typography>
    </Box>
  );
};

export default EtapaResumoFinal;
